<div class="mt-16 flex gap-20 md:mt-24 md:justify-center md:gap-40">
    <a
        class="border-b-4 border-b-transparent pb-4 font-headline text-14 leading-27 text-accent hover:font-medium md:text-18"
        [hyundaiRouterLink]="dealer().pages.imprint"
        routerLinkActive="!border-b-accent font-medium"
    >
        Impressum
    </a>
    <a
        class="border-b-4 border-b-transparent pb-4 font-headline text-14 leading-27 text-accent hover:font-medium md:text-18"
        [hyundaiRouterLink]="dealer().pages.legal"
        routerLinkActive="!border-b-accent font-medium"
    >
        Rechtliche Hinweise
    </a>
    <a
        class="border-b-4 border-b-transparent pb-4 font-headline text-14 leading-27 text-accent hover:font-medium md:text-18"
        [hyundaiRouterLink]="dealer().pages.privacy"
        routerLinkActive="!border-b-accent font-medium"
    >
        Datenschutz
    </a>
</div>
